import { msg } from '@lingui/core/macro';
import { MarginType, Side } from '@/common/constants';
import { OrderType } from '@/feature/order_entry/order_types';

export const FALLBACK_PRICE = '1';

export const DEFAULT_FORM_VALUES = {
  side: Side.long,
  marginType: MarginType.isolated,
  size: '',
  sizeUnit: 'asset' as const,
  price: '',
  stopPrice: '',
  orderSlider: 0,
  orderType: OrderType.limit,
  leverage: 100,
  tpSLEnabled: false,
};

// Lingui descriptors; useBottomLabels resolves them to display strings.
export const BOTTOM_LABELS = [
  {
    label: msg({ comment: 'Order form summary row label', message: 'Liquidation Price' }),
    tooltip: msg({
      comment: 'Order form summary tooltip: liquidation price',
      message:
        'The estimated price at which your position will be liquidated if your margin balance falls below the maintenance margin.',
    }),
  },
  {
    label: msg({ comment: 'Order form summary row label', message: 'Order Value' }),
    tooltip: msg({
      comment: 'Order form summary tooltip: order value',
      message: 'The total notional value of this order (price × size).',
    }),
  },
  {
    label: msg({ comment: 'Order form summary row label', message: 'Margin Required' }),
    tooltip: msg({
      comment: 'Order form summary tooltip: margin required',
      message: 'The amount of collateral you must provide to open this position.',
    }),
  },
] as const;

// The row shows one leg. Contracts ≥ v1.1.7.5 charge the same rate again on close, so
// `perLegTooltip` applies there and `openOnlyTooltip` on markets that still charge on open only.
export const FEE_LABEL = {
  label: msg({ comment: 'Order form fees row label', message: 'Fees' }),
  perLegTooltip: msg({
    comment: 'Order form fees tooltip: the rate shown is for one trade; it is charged on open and again on close',
    message:
      'Fees per trade, shown as maker / taker. You pay them when you open a position and again when you close it. Maker fees apply when your order adds liquidity; taker fees apply when it removes liquidity.',
  }),
  openOnlyTooltip: msg({
    comment: 'Order form fees tooltip: maker / taker',
    message:
      'Trading fees shown as maker / taker. Maker fees apply when your order adds liquidity; taker fees apply when it removes liquidity.',
  }),
} as const;
